import { type ReactNode } from "react";
import { Navigate } from "react-router-dom";

import { useTrackerRoles } from "@/lib/permissions";

export interface RequirePlatformAdminProps {
  fallback?: ReactNode;
  children: ReactNode;
}

/**
 * Mounts its children only for a caller the API calls a platform-admin — our
 * staff's platform-wide screens (WorkspaceService.GetCaller, lib/permissions).
 */
export function RequirePlatformAdmin({ fallback, children }: RequirePlatformAdminProps) {
  const { isPlatformAdmin } = useTrackerRoles();
  if (!isPlatformAdmin) {
    return <>{fallback ?? <Navigate to="/" replace />}</>;
  }
  return <>{children}</>;
}
